import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import userReducer from './reducers/userReducer';
import dataReducer from './reducers/dataReducer';
import savedPreviewReducer from './reducers/savedPreviewReducer';
import { DELETED_SAVED_LIST } from './types';
import { readSavedPreviewCache, writeSavedPreviewCache } from '../utils/savedPreviewCache';
import { API_BASE_URL } from '../constants/api';

import axios from 'axios';
axios.defaults.baseURL = API_BASE_URL;

const initialState = {};

const savedListCache = store => next => action => {
    const result = next(action);
    if (action.type === DELETED_SAVED_LIST) {
        const { uid } = store.getState().savedHighlights;
        const listId = action.payload.id;
        const pages = readSavedPreviewCache(uid);
        delete pages[listId];
        Object.values(pages).forEach(page => {
            page.records = page.records.map(record => ({
                ...record,
                savedListIds: record.savedListIds.filter(id => id !== listId),
            }));
        });
        writeSavedPreviewCache(uid, pages);
    }
    return result;
};
const middleware = [thunk, savedListCache];

const reducers = combineReducers({
    user: userReducer,
    data: dataReducer,
    savedHighlights: savedPreviewReducer
});

const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));
const store = createStore(reducers, initialState, enhancer);

export default store;
